import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import CGV from "@/pages/CGV";
import CreationLogoReunion from "@/pages/CreationLogoReunion";
import CreationLogoParis from "@/pages/CreationLogoParis";
import CreationLogoIleMaurice from "@/pages/CreationLogoIleMaurice";
import DiagnosticDigital from "@/pages/DiagnosticDigital";
import MerciAudit from "@/pages/MerciAudit";
import SiteLocation from "@/pages/SiteLocation";
import SiteLocationMaurice from "@/pages/SiteLocationMaurice";
import DecouverteRS from "@/pages/DecouverteRS";
import DecouverteRSMaurice from "@/pages/DecouverteRSMaurice";
import ConfirmationDecouverteRS from "@/pages/ConfirmationDecouverteRS";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminProtectedRoute from "@/admin/AdminProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminSettings from "@/admin/AdminSettings";
import AdminSecurity from "@/admin/AdminSecurity";
import AdminProspects from "@/admin/AdminProspects";
import AdminInbox from "@/admin/AdminInbox";
import AdminReady from "@/admin/AdminReady";
import AdminLeadsMaurice from "@/admin/AdminLeadsMaurice";
import BlogCoutSiteWebMaurice from "@/pages/BlogCoutSiteWebMaurice";
import BlogWebsiteCostMauritius from "@/pages/BlogWebsiteCostMauritius";
import WhatsAppFloatingButton from "@/components/site/WhatsAppFloatingButton";

function App() {
  return (
    <div className="App bg-[#050507] text-white min-h-screen">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/creation-logo-la-reunion" element={<CreationLogoReunion />} />
            <Route path="/creation-logo-paris" element={<CreationLogoParis />} />
            <Route path="/creation-logo-ile-maurice" element={<CreationLogoIleMaurice />} />
            <Route path="/diagnostic-digital-gratuit" element={<DiagnosticDigital />} />
            <Route path="/merci-audit" element={<MerciAudit />} />
            <Route path="/site-location" element={<SiteLocation />} />
            <Route path="/site-location-maurice" element={<SiteLocationMaurice />} />
            <Route path="/decouverte-rs" element={<DecouverteRS />} />
            <Route path="/decouverte-rs-maurice" element={<DecouverteRSMaurice />} />
            <Route path="/decouverte-rs/confirmation" element={<ConfirmationDecouverteRS />} />

            {/* Blog */}
            <Route path="/blog/cout-site-web-maurice" element={<BlogCoutSiteWebMaurice />} />
            <Route path="/blog/website-cost-mauritius" element={<BlogWebsiteCostMauritius />} />

            {/* Admin (internal prospection tool) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<AdminProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/inbox" element={<AdminInbox />} />
                <Route path="/admin/ready" element={<AdminReady />} />
                <Route path="/admin/prospects" element={<AdminProspects />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
                <Route path="/admin/security" element={<AdminSecurity />} />
                <Route path="/admin/leads-maurice" element={<AdminLeadsMaurice />} />
              </Route>
            </Route>
          </Routes>
          <WhatsAppFloatingButton />
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
